import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

import StepButtons from "./stepButtons";
import Modal from "../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  generateDocument,
} from "../../utils/functions";

import useApi from "../../hooks/useApi";
import Disclaimer from "../../shared/Disclaimer/Disclaimer";

const baseName = `registerProvider.forms.confirmation`;

const Confirmation = ({ institution, referenceNumber, country }) => {
  const { t } = useTranslation();
  const { postApiCAll } = useApi();
  const history = useHistory();
  const [summary, setSummary] = useState(false);
  const [contract, setContract] = useState(false);
  const [modal, setModal] = useState({
    loading: false,
    show: false,
    content: null,
  });

  const endOnboardingProcess = async () => {
    if (!summary || !contract) {
      handleModal(
        false,
        true,
        errorContainer(
          t(`${baseName}.modal.processError.title`),
          t(`${baseName}.modal.processError.content`),
          {
            continueBtn: {
              text: t(`${baseName}.modal.processError.button.accept`),
              action: () => handleModal(false, false, null),
            },
          }
        )
      );

      return;
    }

    try {
      await postApiCAll("/providers/save-temporal-data", {
        referenceNumber,
        businessId: institution,
        closingProcess: true,
      });
      history.push("/providers/login");
    } catch (err) {
      handleModal(
        false,
        true,
        errorContainer(
          t(`${baseName}.modal.requestError.title`),
          t("registerProvider.error"),
          {
            continueBtn: {
              text: t(`${baseName}.modal.requestError.button.close`),
              action: () => handleModal(false, false, null),
            },
          }
        )
      );
    }
  };

  const handleAction = async (url) => {
    handleModal(true, true, loadingHtml());
    try {
      const {
        data: { data },
      } = await postApiCAll(`/reports/${url}`, {
        businessId: institution,
        referenceNumber,
      });
      generateDocument(data);
      handleModal(false, false, null);
      return true;
    } catch (err) {
      handleModal(
        false,
        true,
        errorContainer(
          t(`${baseName}.modal.downloadError.title`),
          t(`${baseName}.modal.downloadError.content`),
          {
            continueBtn: {
              text: t(`${baseName}.modal.downloadError.button.close`),
              action: () => handleModal(false, false, null),
            },
          }
        )
      );
      return false;
    }
  };

  const handleSummary = async () => {
    const downloaded = await handleAction("providers");

    if (!summary && downloaded) {
      setSummary(!summary);
    }
  };

  const handleContract = async () => {
    const downloaded = await handleAction("contract-providers");

    if (!contract && downloaded) {
      setContract(!contract);
    }
  };

  const handleModal = (loading, show, content) => {
    setModal({ loading, show, content });
  };

  return (
    <>
      <div className="register-provider-confirmation">
        <Disclaimer containerClass={"onboarding-confirmation"}>
          <p>{t("disclaimer.split_text.text_1")}</p>
          <p>{t("disclaimer.split_text.text_2")}</p>
          <p>{t("disclaimer.split_text.text_3")}</p>
        </Disclaimer>
        <h3>{t(`${baseName}.title`)}</h3>
        <ol className="confirmation-steps">
          <li>
            {t(`${baseName}.${country}.steps.1`)}{" "}
            <PrimaryButton
              id="confirmation-summary-btn"
              className="confirmation-btn-sm"
              size="small"
              onClick={handleSummary}
            >
              {t(`${baseName}.resumeAction`)}
            </PrimaryButton>{" "}
            <PrimaryButton
              id="confirmation-contract-btn"
              className="confirmation-btn-sm separator"
              size="small"
              onClick={handleContract}
            >
              {t(`${baseName}.contractAction`)}
            </PrimaryButton>
          </li>
          <li>{t(`${baseName}.${country}.steps.2`)}</li>
          <li>{t(`${baseName}.${country}.steps.3`)}</li>
          <li>{t(`${baseName}.${country}.steps.4`)}</li>
          <li>{t(`${baseName}.${country}.steps.5`)}</li>
          {country == "CR" && (
            <>
              <li>
                <p>{t(`${baseName}.${country}.steps.6.1`)}</p>
                <p>
                  {t(`${baseName}.${country}.steps.6.2`)}{" "}
                  <u>{t(`${baseName}.${country}.steps.6.3`)}</u>
                </p>
              </li>
              <li>
                <p>{t(`${baseName}.${country}.steps.7.1`)}</p>
                <p>{t(`${baseName}.${country}.steps.7.2`)}</p>
                <p>{t(`${baseName}.${country}.steps.7.3`)}</p>
                <p>{t(`${baseName}.${country}.steps.7.4`)}</p>
                <p>{t(`${baseName}.${country}.steps.7.5`)}</p>
              </li>
            </>
          )}
          {country == "PA" && (
            <li>
              <p>{t(`${baseName}.${country}.steps.6.1`)}</p>
              <p>{t(`${baseName}.${country}.steps.6.2`)}</p>
              <p>{t(`${baseName}.${country}.steps.6.3`)}</p>
              <p>{t(`${baseName}.${country}.steps.6.4`)}</p>
              <p>{t(`${baseName}.${country}.steps.6.5`)}</p>
            </li>
          )}
        </ol>
        {country === "PA" && <p>{t(`${baseName}.${country}.contact`)}</p>}
        <p>{t(`${baseName}.emailMessage`)}</p>
        <p>{t(`${baseName}.${country}.contactInfo`)}</p>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <StepButtons nextStep={endOnboardingProcess} last />
      </div>

      <Modal show={modal.show}>
        {modal.loading && modal.content}
        {!modal.loading && (
          <div className="molda-setting-content">{modal.content}</div>
        )}
      </Modal>
    </>
  );
};

export default Confirmation;
